export default [
  'exp1: Network Cabling and Devices',
  'exp2: IP Addressing Version 4',
  'exp3: IP Addressing: Version 6',
  'exp4: Static Routing',
  'exp5: RIPv2 and RIPng',
  'exp6: Enhanced Interior Gateway Routing',
  'exp7: Open Shortest Path Firs ',
  'exp8: Configuration of Basic and Real Devices',
  'cider',
  'labNetwork_Final',
  'DrKhalid_Final',
];
